module.exports = __webpack_public_path__ + "img/right-image.6077d773.png";